var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._v(" My Orders "),_c('br'),_c('br'),_c('br'),(_vm.orders)?_c('Orders',{attrs:{"orders":_vm.orders,"customOrders":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }